export default function isButton(target) {
  if (target) {
    return target.tagName === "BUTTON"
  }
}
